module.exports = __webpack_public_path__ + "media/images/bf-favicon-8bb4a28da283d97e4b69f0735b423fc3.png";